import { Component, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { interval } from 'rxjs';

const timeInterval = interval(1000);

interface CountDownData {
  time: number;
  isEditing: boolean;
}

@Component({
  selector: 'app-count-down',
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.scss'],
})
export class CountDownComponent implements AfterViewInit {
  connectionLost = false;

  constructor(
    public dialogRef: MatDialogRef<CountDownComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CountDownData
  ) {}

  ngAfterViewInit() {
    this.connectionLost = false;
    this.startCountDown('countdown-number', 'timerCircle', 'countdown-border', this.data.time, 5);
  }

  startCountDown(
    elementID: string,
    svgID: string,
    pulseID: string,
    seconds: number,
    warningStart: number
  ) {
    // get element to add the timer
    const countdownNumberEl = document.getElementById(elementID);
    // countdownNumberEl.style.visibility = 'visible';
    const time: number = seconds;

    // convert time to a string "30s"
    const timeString = time.toString() + 's';

    // get svg Circle by id
    const svgCircle = document.getElementById(svgID);
    // svgCircle.style.visibility = 'visible';

    // add animation to the svg Circle
    svgCircle.style.animation = 'countdownTimer ' + timeString + ' linear forwards';

    // get timer pulse
    const timerPulse = document.getElementById(pulseID);
    // add animation to timer pulse

    const timeIntervalSubscription = timeInterval.subscribe(() => {
      seconds = --seconds <= -1 ? time : seconds;
      countdownNumberEl.textContent = seconds.toString();
      if (seconds === 0) {
        // remove animation
        svgCircle.style.animation = '';
        // timerPulse.style.animation = "";

        // stop count down
        timeIntervalSubscription.unsubscribe();
        // alert('time is up')

        this.connectionLost = true;
      }

      if (seconds === warningStart) {
        timerPulse.style.animation = 'countdownPulse 1s ease-out ' + warningStart.toString();
        countdownNumberEl.style.color = 'var(--paydRed)';
      }
    });
  }

  reconnect() {
    this.dialogRef.close('reconnect');
  }
}
